"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InscriptionClient = void 0;
const axios_1 = __importDefault(require("axios"));
const InscriptionError_1 = require("./InscriptionError");
const qs = require("qs");
const version = require("../package.json")?.version || "local";
const packageVersion = `npm-inscription-v${version}`;
class InscriptionClient {
    constructor(key = "", environment = "live") {
        this.api_key = key;
        this.env = environment;
        const createInstance = () => {
            const client = axios_1.default.create({
                baseURL: environment === "live"
                    ? `https://api.ordinalsbot.com`
                    : `https://testnet-api.ordinalsbot.com`,
                timeout: 30000,
                headers: {
                    "x-api-key": this.api_key,
                    Connection: "Keep-Alive",
                    "Content-Type": "application/json",
                    "Keep-Alive": "timeout=10",
                    "User-Agent": packageVersion,
                },
            });
            client.interceptors.response.use(({ data }) => ("data" in data ? data.data : data), (err) => {
                if (axios_1.default.isAxiosError(err)) {
                    throw new InscriptionError_1.InscriptionError(err.message, err.response?.statusText, err.response?.status);
                }
                if (err instanceof Error)
                    throw err;
                return err;
            });
            return client;
        };
        this.instanceV1 = createInstance();
    }
    get axiosInstance() {
        return this.instanceV1;
    }
    async getPrice(priceRequest) {
        return this.instanceV1.get(`/price`, {
            params: priceRequest,
        });
    }
    async createOrder(order) {
        return this.instanceV1.post(`/order`, order);
    }
    async getOrder(id) {
        return this.instanceV1.get(`/order`, {
            params: { id },
        });
    }
    async createCollection(collection) {
        let plainObject = Object.assign({ ...collection });
        let files = collection?.files;
        for (let index in files) {
            let file = files[index];
            let keys = Object.keys(file);
            for (let key in keys) {
                let propName = keys[key];
                plainObject[`files[${index}][${propName}]`] = file[propName];
            }
        }
        delete plainObject.files;
        let data = qs.stringify(plainObject);
        let config = {
            method: "post",
            maxBodyLength: Infinity,
            url: this.instanceV1.getUri() + "/collectioncreate",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            data: data,
        };
        return axios_1.default.request(config);
    }
    async createCollectionOrder(collectionOrder) {
        return this.instanceV1.post(`/collectionorder`, collectionOrder);
    }
    async createTextOrder(order) {
        return this.instanceV1.post(`/textorder`, order);
    }
    async getInventory() {
        return this.instanceV1.get(`/inventory`);
    }
    async setReferralCode(referral) {
        return this.instanceV1.post(`/referrals`, referral);
    }
    async getReferralStatus(referral) {
        return this.instanceV1.get(`/referrals`, {
            params: referral,
        });
    }
}
exports.InscriptionClient = InscriptionClient;
//# sourceMappingURL=client.js.map